import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationInputStyle, applyMaxLengths } from "../../constants";
import ApplyRequiredError from "./ApplyRequiredError";
import { updateAppData } from "../../utils/actionUtils";
import { Box, Stack } from "@mui/material";
import FettiInput from "../FettiInput";
import SimpleApplyField from "./SimpleApplyField";
import ApplyLocationAutocomplete from "./ApplyLocationAutocomplete";
import { valueToPhoneNumber } from "../../utils/utils";
import QuestionApply from "./QuestionApply";

const QuestionsApply = () => {
  const dispatch = useDispatch();
  const apply = useSelector((state) => state.apply);
  const appData = useSelector((state) => state.apply.app);
  const serverQuestions = useSelector(
    (state) => state.apply.serverData.questions
  );
  return (
    <>
      <Stack direction="column" spacing={1}>
        <Box sx={ApplicationInputStyle.categoryLabel}>Employer Questions</Box>
        <Box sx={ApplicationInputStyle.subheader}>
          {apply.jobData.company} requires applicants to answer the following
          questions.
        </Box>
      </Stack>
      {serverQuestions &&
        serverQuestions.map((question, index) => {
          return <QuestionApply data={question} key={index} idx={index} />;
        })}
    </>
  );
};

export default QuestionsApply;
